export const getUpdatedHeadingStructureElementsFromState = (htmlStrings, ruleState, globalSectionStateMap) => {
  if (globalSectionStateMap === undefined) {
    return htmlStrings;
  }
  return htmlStrings.map(_ref => {
    let {
      id,
      uiElementId,
      htmlString,
      attributeId,
      sectionId
    } = _ref;
    const globalSectionElementState = globalSectionStateMap == null ? void 0 : globalSectionStateMap.get(id);
    const headingState = ruleState == null ? void 0 : ruleState.find(state => state.uiElementId === uiElementId);
    return {
      attributeId,
      htmlString: (globalSectionElementState == null ? void 0 : globalSectionElementState.htmlString) ?? (headingState == null ? void 0 : headingState.htmlString) ?? htmlString,
      id,
      sectionId,
      uiElementId
    };
  });
};
//# sourceMappingURL=get-updated-heading-structure-elements-from-state.js.map